import { Box, Typography } from "@material-ui/core";
import React from "react";

import { InvestmentStyleDiagnosisRequestPurposesEnum as PurposeEnum } from "@/api/generated";
import {
  DIAGNOSIS_QUESTION_TEXT,
  Option,
  PURPOSE_OPTIONS,
} from "@/constants/investmentStyleDiagnosisQuestions";

import { DiagnosisInvestmentStyleCheckboxList } from "../DiagnosisInvestmentStyleCheckboxList";
import { DiagnosisInvestmentStyleFreeText } from "../DiagnosisInvestmentStyleFreeText";

import { useStepStyles } from "./stepStyles";

type PurposeStepProps = {
  purposes: PurposeEnum[];
  onPurposesChange: (next: PurposeEnum[]) => void;
  primaryOptions: Option<PurposeEnum>[];
  primaryPurpose: PurposeEnum | null;
  onPrimaryPurposeChange: (next: PurposeEnum | null) => void;
  idealText: string;
  onIdealTextChange: (value: string) => void;
};

const PurposeStep: React.FC<PurposeStepProps> = ({
  purposes,
  onPurposesChange,
  primaryOptions,
  primaryPurpose,
  onPrimaryPurposeChange,
  idealText,
  onIdealTextChange,
}) => {
  const classes = useStepStyles();
  return (
    <>
      <Typography className={classes.title}>目的と未来</Typography>
      <Typography className={classes.description}>{DIAGNOSIS_QUESTION_TEXT[1]}</Typography>
      <Box className={classes.inputArea}>
        <DiagnosisInvestmentStyleCheckboxList
          options={PURPOSE_OPTIONS}
          selected={purposes}
          onChange={onPurposesChange}
        />
      </Box>
      <Typography className={classes.subHeading}>その中で最も重要視するものを1つ選んでください（単一選択）</Typography>
      <Box className={classes.inputArea}>
        <DiagnosisInvestmentStyleCheckboxList
          options={primaryOptions}
          selected={primaryPurpose ? [primaryPurpose] : []}
          single
          onChange={(next) => onPrimaryPurposeChange(next[0] ?? null)}
        />
      </Box>
      <Box className={classes.divider} />
      <Typography className={classes.subHeading}>実現したい未来</Typography>
      <Typography className={classes.subDescription}>
        不動産投資によってどのような状態が作れると嬉しいですか？（自由記述・任意）
      </Typography>
      <DiagnosisInvestmentStyleFreeText
        value={idealText}
        ariaLabel="実現したい未来"
        placeholder={"記入例：\n老後のお金を心配せず、安心して暮らしたい\n収入のためだけに働かず、やりたい仕事を選べるようになりたい"}
        onChange={onIdealTextChange}
      />
    </>
  );
};

export default PurposeStep;
